document.addEventListener('DOMContentLoaded', function () {
  const langSwitchModal = document.getElementById('lang-switch-modal');
  if (!langSwitchModal) return;

  const germanVisitor = window.location.pathname.includes('/en-de') && window.navigator.languages.includes('de');
  const englishGermanVisitor = window.location.pathname.includes('/de') && window.navigator.languages.includes('en');

  const cookieDidomiConsent = document.cookie.includes('euconsent-v2');
  const cookieLangSwitch = document.cookie.includes('lang-switch-modal-closed');
  if ((germanVisitor || englishGermanVisitor) && !cookieLangSwitch) {
    setTimeout(() => {
      langSwitchModal.classList.add('fadein');
    }, cookieDidomiConsent ? 0 : 5000);
    const stayButton = langSwitchModal.querySelector('#lang-switch-stay-button');
    stayButton.addEventListener('click', () => {
      langSwitchModal.classList.remove('fadein');
      document.cookie = 'lang-switch-modal-closed=true';
    });
  }
});
